import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../api/auth/useAuth";
import { continueAuthPath } from "./authReturn";
import { LoadingSpinner } from "./LoadingSpinner";
import { Paths } from "./paths";

export const ProtectedRoute = () => {
  const { token, isRestored } = useAuth();
  const location = useLocation();

  // Don't decide before the stored session has been read.
  if (!isRestored) return <LoadingSpinner />;

  return token ? (
    <Outlet />
  ) : (
    <Navigate to={continueAuthPath(Paths.LOGIN, location)} replace />
  );
};
